import { useMemo } from 'react';
import type { Material } from '@igus/iglidur-free-form-hub-interfaces';
import type { NextRouter } from 'next/router';
import type { freeFormFilterValues } from '../product-filters/types';

export const useSelectedMaterialColor = (materials: Material[] | undefined, router: NextRouter) =>
  useMemo(() => {
    const selectedMaterialList = (router.query as freeFormFilterValues)?.material?.split('%2C')[0]?.split(',') || [];
    const defaultColor = '#ffeec8';

    const color = materials?.find(
      material => material.id === selectedMaterialList[selectedMaterialList.length - 1]
    )?.colorHex;
    return color || defaultColor;
  }, [materials, router.query]);
